import React, { useEffect, useState, useRef } from "react";
import _ from "lodash";
import classNames from "classnames";
import { getTextWidth } from "../../utils/commonUtil";
import Popover from "../Popover";
import Tooltip from "../Widgets/Tooltip";
import styles from "./Table.module.scss";
import { InternalFilter } from "./InternalTableFilters";
import { ReactComponent as SortUpIcon } from "./ic-table-sort-asc.svg";
import { ReactComponent as SortUpActiveIcon } from "./ic-table-sort-asc-active.svg";
import { ReactComponent as SortDownIcon } from "./ic-table-sort-desc.svg";
import { ReactComponent as SortDownActiveIcon } from "./ic-table-sort-desc-active.svg";

const RenderHeaderCell = ({
                              sortState,
                              column,
                              toggleSort,
                              width,
                              columnFilterOptions,
                              columnFilterState = {},
                              updateFilterState,
                              stickLastColumn,
                              lastColumnStickyStyleRef,
                              stickyColumnStyleRef,
                              stickColumn,
                              headerCellClassName,
                              headerHandleClassName,
                              innerTable,
                              dataTestId,
                              onResize,
                          }) => {
    const id = column.id;
    const sortingEnabled = !!sortState && _.get(column, "sort.enabled", true);
    const filterEnabled = _.get(column, "filter.enabled", false);
    const isSorted = sortingEnabled && sortState.column === id;
    const sortOrder = sortingEnabled && isSorted && sortState.sortOrder;
    const hideHeaderHandle = _.get(column, "hideHeaderHandle", false);
    const [showHeaderTooltip, setShowHeaderTooltip] = useState(false);
    const headerCellId = `${column.header}-${id}`;
    const headerRef = useRef(null);

    const className = classNames(column.headerClass, styles['header-cell'], headerCellClassName, {
        [lastColumnStickyStyleRef.current.dataset.styleid]: stickLastColumn,
        [stickyColumnStyleRef.current.dataset.styleid]: stickColumn,
        [styles['inner-table-column']]: innerTable
    });
    const style = {
        flex: column.fixedWidth ? `0 0 ${width}px` : `1 0 ${width}px`
    };

    const updateColumnFilter = (values) => {
        updateFilterState({
            id,
            values
        });
    };

    const headerLabel = `${column.header}${(filterEnabled && columnFilterState.activeCount > 0 ? ' (' + (columnFilterState.activeCount) + ')' : '')}`;
    

    useEffect(() => {
        if (headerRef?.current) {
            // Sets the "showHeaderTooltip" true if the width of the column is less than the width of the text.
            setShowHeaderTooltip(headerRef.current.offsetWidth < getTextWidth(headerLabel));
        }
    }, [width, columnFilterState, headerRef.current]);


    return <div
        className={className}
        style={style}
        data-testid={dataTestId}>

        <div id={headerCellId} ref={headerRef} className={styles["header-label"]}>
            {column.popoverText && <Popover triggerClassName={styles['header-cell-popover-trigger']}>{column.popoverText}</Popover>}
            {<span>{headerLabel}</span>}
            {showHeaderTooltip && <Tooltip>{headerLabel}</Tooltip>}
        </div>
        <div className={styles.widgets}>
            {filterEnabled && <InternalFilter filterConfig={column.filter} columnFilterOptions={columnFilterOptions}
                columnFilterState={columnFilterState}
                updateColumnFilter={updateColumnFilter} />}
            {sortingEnabled && !isSorted &&
            <button className={styles['sort-icons']} onClick={() => toggleSort({ id })}>
                <SortUpIcon/>
                <SortDownIcon/>
            </button>}
            {isSorted && <button className={styles["active-sort-icons"]} onClick={() => toggleSort({ id })}>
                {sortOrder === "asc" ? <SortUpActiveIcon/> : <SortDownActiveIcon/>}
            </button>}
        </div>
        {!hideHeaderHandle ? <div
            onMouseDown={column.isColumnResizable ? onResize : _.noop}
            className={classNames(styles['header-handle'], {[styles["resize-handle"]]: column.isColumnResizable}, headerHandleClassName)}/> : <div/>}
    </div>
};

export default RenderHeaderCell;
